export type ImageOrientation = 'portrait' | 'landscape' | 'square';

export function getImageOrientation(width: number, height: number): ImageOrientation {
	if (width <= 0 || height <= 0) return 'portrait';

	const ratio = width / height;
	if (ratio > 1.05) return 'landscape';
	if (ratio < 0.95) return 'portrait';
	return 'square';
}
